import { jsx as _jsx } from "react/jsx-runtime";
import { IconButton } from '@caspeco/casper-ui-library.components.icon-button';
import { Icons } from '@caspeco/casper-ui-library.components.icon';
export function PlusButton({ ariaLabel, buttonSize, onClick, isDisabled, }) {
    return (_jsx(IconButton, { variant: "ghost", icon: Icons.Increase, "aria-label": ariaLabel, size: buttonSize, onClick: onClick, isDisabled: isDisabled }));
}
//# sourceMappingURL=plus-button.js.map